import { useEffect, useState } from "react";
import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { TostadorFetching } from "../../../class/fetchTostador";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { useDate } from "../../../hooks/useDate";

export default function TroneraInferiorL2() {
  // Objecto default del state
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Peticion inicial de esta grafica
  const initialFetch = new TostadorFetching()
    .setIdSeccion(8)
    .setSecuencia(7)
    .setFrecuencia(720)
    .setDias(7);

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [humedad, setHumedad] = useState(defaultObject);
  const [troneraS, setTroneraS] = useState(defaultObject);
  const [troneraSio2, setTroneraSio2] = useState(defaultObject);

  useEffect(() => {
    async function fetchData() {
      const { data } = await getValoresPeriodo(initialFetch);
      populateHumedad(data);
      populateTroneraS(data);
      populateTroneraSio2(data);
      setDateHook(data, "TRON_UNDER_L2_Humedad");

      setTimeout(() => {
        fetchData();
      }, 300000);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateHumedad(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "TRON_UNDER_L2_Humedad"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setHumedad({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTroneraS(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "TRON_UNDER_L2_S"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTroneraS({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTroneraSio2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "TRON_UNDER_L2_SiO2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTroneraSio2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            title="Tronera Inferior L2"
            subtitle={"Periodo " + fullDate()}
            zoom="x"
          >
            <Chart.Column name="Humedad L2" data={humedad.value} />
            <Chart.Column name="Tronera L2 S" data={troneraS.value}  yAxis={1}/>
            <Chart.Column name="Tronera L2 Sio2" data={troneraSio2.value} />

            <Chart.XAxis allowDecimals={false} categories={humedad.fecha} />
            <Chart.YAxis
              labelSuffix=" °%"
              title="Contenido SIO2, %"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" °%"
              title="Conteido H2O - S, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
            />
            <Chart.YAxis labelSuffix=" %" />
            <Chart.Tooltip valueSuffix=" %" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
